import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function NewsPagination({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  const createPageArray = () => {
    const delta = 1;
    const current = Number(currentPage);
    const total = Number(totalPages);

    const range = [];
    const result = [];

    const start = Math.max(2, current - delta);
    const end = Math.min(total - 1, current + delta);

    range.push(1);
    for (let i = start; i <= end; i++) range.push(i);
    if (total > 1) range.push(total);

    let last;
    for (const page of range) {
      if (last && page - last > 1) result.push('...');
      result.push(page);
      last = page;
    }

    return result;
  };

  const pages = createPageArray();

  return (
    <div className="py-6">
      {/* ===================== MOBILE ===================== */}
      <div className="md:hidden">
        {/* Numbers */}
        <div className="flex flex-wrap justify-center gap-2 mb-4">
          {pages.map((p, i) =>
            p === '...' ? (
              <span key={`dots-m-${i}`} className="px-2 text-gray-500 text-xs">
                ...
              </span>
            ) : (
              <button
                key={`page-m-${p}-${i}`}
                onClick={() => onPageChange(p)}
                className={`h-8 min-w-[32px] rounded-full text-xs font-semibold border transition
                  ${
                    p === currentPage
                      ? 'bg-primary-500 text-white border-transparent'
                      : 'bg-white border-gray-300'
                  }`}
              >
                {p}
              </button>
            )
          )}
        </div>

        {/* Prev & Next */}
        <div className="flex gap-3 max-w-sm mx-auto">
          <button
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className={`flex-1 h-9 rounded-full text-xs font-semibold transition
              ${
                currentPage === 1
                  ? 'bg-gray-200 text-gray-400'
                  : 'bg-white shadow hover:bg-primary-500 hover:text-white'
              }`}
          >
            <div className="flex items-center justify-center gap-1">
              <ChevronLeft className="w-4 h-4" />
              Prev
            </div>
          </button>

          <button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className={`flex-1 h-9 rounded-full text-xs font-semibold transition
              ${
                currentPage === totalPages
                  ? 'bg-gray-200 text-gray-400'
                  : 'bg-white shadow hover:bg-primary-500 hover:text-white'
              }`}
          >
            <div className="flex items-center justify-center gap-1">
              Next
              <ChevronRight className="w-4 h-4" />
            </div>
          </button>
        </div>
      </div>

      {/* ===================== DESKTOP ===================== */}
      <div className="hidden md:flex flex-wrap items-center justify-center gap-3">
        {/* Prev */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`flex items-center gap-1 px-5 h-10 min-w-[40px] rounded-full text-sm font-semibold transition
            ${
              currentPage === 1
                ? 'bg-gray-200 text-gray-400'
                : 'bg-white shadow hover:bg-primary-500 hover:text-white'
            }`}
        >
          <ChevronLeft className="w-4 h-4" />
          Prev
        </button>

        {/* Numbers */}
        <div className="flex flex-wrap items-center justify-center gap-2">
          {pages.map((p, i) =>
            p === '...' ? (
              <span key={`dots-d-${i}`} className="px-3 text-gray-500 text-xs">
                ...
              </span>
            ) : (
              <button
                key={`page-d-${p}-${i}`}
                onClick={() => onPageChange(p)}
                className={`h-10 min-w-[40px] rounded-full text-sm font-semibold border transition
                  ${
                    p === currentPage
                      ? 'bg-primary-500 text-white border-transparent'
                      : 'bg-white border-gray-300 hover:bg-primary-500 hover:text-white'
                  }`}
              >
                {p}
              </button>
            )
          )}
        </div>

        {/* Next */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`flex items-center gap-1 px-5 h-10 min-w-[40px] rounded-full text-sm font-semibold transition
            ${
              currentPage === totalPages
                ? 'bg-gray-200 text-gray-400'
                : 'bg-white shadow hover:bg-primary-500 hover:text-white'
            }`}
        >
          Next
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
